export default __webpack_public_path__ + "static/media/adst_banner.c3f808c2.png";